import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { EventDetailsSectionTitle } from '../EventDetails/EventDetails';

export type ShareInlineProps = {
    hasShareInline: boolean;
    shouldShowRicherEventDetails?: boolean;
};

export const ShareInline = ({
    hasShareInline,
    shouldShowRicherEventDetails,
}: ShareInlineProps) => {
    if (!hasShareInline) {
        return null;
    }

    const Title: React.FC = ({ children }) => (
        <>
            {shouldShowRicherEventDetails ? (
                <EventDetailsSectionTitle>
                    <h3>{children}</h3>
                </EventDetailsSectionTitle>
            ) : (
                <h3
                    id="share-inline-heading"
                    className="label-primary normal-case l-sm-align-left"
                >
                    {children}
                </h3>
            )}
        </>
    );

    return (
        <section
            className="share-inline"
            aria-labelledby="share-inline-heading"
        >
            <div className="l-sm-mar-bot-4">
                <Title>{gettext('Share with friends')}</Title>
                <div id="listings-root__share-event"></div>
            </div>
        </section>
    );
};
